import { Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
import { authGuard } from './core/guards';

export const routes: Routes = [
  {
    path: 'account',
    loadChildren: () => import('./features/account/account.routes').then((m) => m.routes),
  },
  {
    path: 'login',
    redirectTo: 'account/login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./features/features.routes').then((m) => m.routes),
    canActivate: [authGuard],
  },
];
